/* Formatadores pt-BR, porte literal de legacy/evolucao_classificador.html.
 *
 * Cada um destes carrega uma decisao que estava comentada no original. Perder
 * qualquer uma e regressao silenciosa, entao a transcricao e deliberada e os
 * testes em format.test.ts prendem o comportamento. */

export const MESES = ["jan", "fev", "mar", "abr", "mai", "jun",
                      "jul", "ago", "set", "out", "nov", "dez"];

export const ALL_ID = "__ALL__";

export function fmtMes(s: string, longo = false): string {
  const [y, m] = s.split("-").map(Number);
  return longo ? `${MESES[m - 1]}/${y}` : `${MESES[m - 1]}/${String(y).slice(2)}`;
}

export const brl = (n: number): string =>
  n.toLocaleString("pt-BR", { maximumFractionDigits: 0 });

export const brl2 = (n: number): string =>
  n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Compacta em "mi"/"mil", mas nunca colapsa centavos: abaixo de R$1 mostra o valor. */
export function compact(n: number): string {
  const a = Math.abs(n);
  if (a >= 1e6) return (n / 1e6).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + " mi";
  if (a >= 1e3) return (n / 1e3).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + " mil";
  if (a > 0 && a < 1) return brl2(n);
  return brl(n);
}

/** `DESPESA - MERCADO` -> `MERCADO`. O prefixo ja e o fluxo, mostrado a parte. */
export const shortName = (n: string): string =>
  n.split(" - ").slice(1).join(" - ") || n;

/** Celula de tabela: zero vira travessao, e um lancamento real NUNCA vira "0". */
export const cell = (v: number | null | undefined): string =>
  !v ? "–" : v < 1 ? brl2(v) : brl(v);

export const pct = (v: number | null | undefined, casas = 1): string =>
  v === null || v === undefined
    ? "–"
    : (v * 100).toLocaleString("pt-BR", { maximumFractionDigits: casas }) + "%";

export const intBR = (n: number): string => n.toLocaleString("pt-BR");

export const mean = (values: number[]): number =>
  values.length ? values.reduce((a, b) => a + b, 0) / values.length : 0;

/** Ordenacao alfabetica pt-BR: sem isso "Ó" cai depois de "Z". */
export const byName = (a: string, b: string): number => a.localeCompare(b, "pt-BR");

export const shortId = (id: string): string =>
  id === ALL_ID ? "todos" : id.slice(0, 8);

export function userLabel(u: {
  user_id: string; months: number; categories: number; total: number;
  is_aggregate: boolean;
}, totalUsers = 0): string {
  return u.is_aggregate
    ? `TODOS os usuários${totalUsers ? ` (soma de ${totalUsers})` : ""}`
    : `${shortId(u.user_id)}…  ·  ${u.months} meses  ·  ${u.categories} cat  ·  R$ ${compact(u.total)}`;
}

/** Ordem canônica dos fluxos: entra, sai, muda de lugar. */
export const FLOWS = ["RECEITA", "DESPESA", "MOVIMENTACAO"];

export const FLOW_COLOR: Record<string, string> = {
  RECEITA: "var(--receita)",
  DESPESA: "var(--despesa)",
  MOVIMENTACAO: "var(--movim)",
};

export const flowColor = (flow: string): string => FLOW_COLOR[flow] ?? "var(--ink-3)";

export function fmtDateTime(iso?: string | null): string {
  if (!iso) return "–";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

export function fmtBytes(n?: number | null): string {
  if (!n) return "–";
  if (n >= 1 << 20) return (n / (1 << 20)).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + " MB";
  if (n >= 1 << 10) return (n / (1 << 10)).toLocaleString("pt-BR", { maximumFractionDigits: 0 }) + " KB";
  return `${n} B`;
}
